import { FC } from 'react';

import { CaseStudies } from 'lib/sanity/types';

import CaseStudyGridItem from 'atoms/CaseStudyGridItem';

export interface Props {
  block: CaseStudies;
  className?: string;
  title?: string | null;
  aspectRatio?: number;
  handleOnClick?: (title: string, subtitle?: string | null) => any;
}

const MoreCaseStudy: FC<Props> = ({
  block,
  className,
  title,
  aspectRatio,
  handleOnClick,
}) => {
  return (
    <div className={className}>
      {title && (
        <div className="text-small desktop:text-desktop-small text-gray-04 mb-content-narrow">
          {title}
        </div>
      )}
      {block && (
        <div className="grid grid-cols-1 tablet:grid-cols-2 gap-x-content-skinny tablet:gap-x-content-narrow gap-y-content-normal">
          {block.map(
            ({ _key, title, subtitle, description, images, video, slug }) => {
              return (
                <CaseStudyGridItem
                  key={_key}
                  title={title}
                  subtitle={subtitle}
                  description={description}
                  images={images}
                  video={video}
                  slug={slug}
                  isLandingTab={false}
                  handleOnClick={handleOnClick}
                  aspectRatio={aspectRatio}
                />
              );
            },
          )}
        </div>
      )}
    </div>
  );
};

export default MoreCaseStudy;
